<ng-container *ngIf="form !== null">
  <div class="cf-dlg">

    <!-- HEADER -->
    <div class="cf-dlg-header">
      <div class="cf-dlg-icon"><mat-icon>event_busy</mat-icon></div>
      <div>
        <h2 class="cf-dlg-title">{{ bajas.id > 0 ? 'Editar baja' : 'Nueva solicitud de baja' }}</h2>
        <p class="cf-dlg-subtitle">Registra el período de baja y sube el documento</p>
      </div>
    </div>

    <!-- BODY -->
    <div class="cf-dlg-body">
      <form [formGroup]="form" (ngSubmit)="onSubmit()">

        <div class="cf-dlg-row">
          <mat-form-field class="w-100" appearance="outline">
            <mat-label>Empleado</mat-label>
            <mat-select formControlName="employees_Id">
              <mat-option *ngFor="let e of empleados; trackBy: trackByIndex" [value]="e.uid">{{ e.name }}</mat-option>
            </mat-select>
            <mat-hint>Empleado que solicita la baja</mat-hint>
            <mat-error *ngIf="form.controls['employees_Id'].hasError('required')">
              El empleado es <strong>obligatorio</strong>
            </mat-error>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Inicio de la baja</mat-label>
            <input matInput [matDatepicker]="picker" formControlName="inicio">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
            <mat-error *ngIf="form.controls['inicio'].hasError('required')">
              La fecha de inicio es <strong>obligatoria</strong>
            </mat-error>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Fin de la baja</mat-label>
            <input matInput [matDatepicker]="picker2" formControlName="fin">
            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
            <mat-datepicker #picker2></mat-datepicker>
          </mat-form-field>
        </div>

        <mat-form-field class="w-100" appearance="outline">
          <mat-label>Motivo</mat-label>
          <textarea matInput rows="4" formControlName="motivo"></textarea>
          <mat-hint>Motivo de la solicitud de baja</mat-hint>
          <mat-error *ngIf="form.controls['motivo'].hasError('required')">
            El motivo es <strong>obligatorio</strong>
          </mat-error>
        </mat-form-field>

        <span class="cf-dlg-section__label">Documento de la baja</span>

        <ng-container *ngIf="!isUploading && !fileUid">
          <div class="cf-dlg-upload-zone">
            <label class="cf-dlg-upload-btn" for="img-input">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                <path d="M464 64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zm-6 336H54a6 6 0 0 1-6-6V118a6 6 0 0 1 6-6h404a6 6 0 0 1 6 6v276a6 6 0 0 1-6 6zM128 152c-22.1 0-40 17.9-40 40s17.9 40 40 40 40-17.9 40-40-17.9-40-40-40zM96 352h320v-80l-87.5-87.5c-4.7-4.7-12.3-4.7-17 0L192 304l-39.5-39.5c-4.7-4.7-12.3-4.7-17 0L96 304v48z"/>
              </svg>
              Imagen (PNG / JPG)
            </label>
            <label class="cf-dlg-upload-btn" for="pdf-input">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
                <path d="M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48z"/>
              </svg>
              PDF
            </label>
          </div>
          <input id="img-input" type="file" (change)="uploadFile($event)" accept=".png,.jpg,.jpeg" style="display:none">
          <input id="pdf-input" type="file" (change)="uploadFile($event)" accept=".pdf" style="display:none">
        </ng-container>

        <div class="cf-dlg-upload-loading" *ngIf="isUploading">
          <div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div>
          <p>Subiendo archivo…</p>
        </div>

        <div class="cf-dlg-upload-success" *ngIf="fileUid && !isUploading">
          <mat-icon>check_circle</mat-icon>
          Archivo subido correctamente
          <button mat-icon-button (click)="deleteFile()" style="margin-left:auto" title="Eliminar archivo">
            <mat-icon style="font-size:16px; color:var(--cf-text-muted)">delete</mat-icon>
          </button>
        </div>

      </form>
    </div>

    <!-- FOOTER -->
    <div class="cf-dlg-footer">
      <button mat-stroked-button class="cf-dlg-btn-secondary" (click)="cancel()">Cancelar</button>
      <button mat-flat-button class="cf-dlg-btn-primary" (click)="onSubmit()">
        <mat-icon>save</mat-icon> Guardar
      </button>
    </div>

  </div>
</ng-container>
